import styled from '@emotion/styled'
import React from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { __constants } from '../../constants'

const SelectDialCode = ({ setMobileNumber, subAdmin }) => {
    const number = `${subAdmin?.dialCode}${subAdmin?.mobileNo}`;
   
    return (
        <Container>
            <PhoneInput
                containerClass={"containerClass"}
                buttonClass={"buttonClass"}
                value={number === "undefinedundefined" ? __constants.defaulDialCode : number}
                inputProps={{
                    name: 'phone',
                    required: true
                }}
                placeholder={"Mobile number"}
                onChange={(phone, country) => { setMobileNumber({ phone, country }) }}
            />
        </Container>
    )
}

const Container = styled("div")`
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    .containerClass{
        display: flex;
        max-width: unset;
        width: 100% !important;
        /* background-color: red; */
        padding: 10px 0;
        input{
            width: 100%;
            background: none;
            outline: none;
            border: none;
            padding-left: 60px;
            font-size: 1rem;
        }
    }
    .buttonClass{
        background: none;
        border: none;
    }
`;

export default SelectDialCode